export enum WFXRolesEnum {
    HEAD_OF_TECHNICAL = "HEAD OF TECHNICAL",
    HEAD_OF_QUALITY = "HEAD OF QUALITY",
    SAMPLE_ROOM_MANAGER = "SAMPLE ROOM MANAGER",
    WAREHOUSE_MANAGER = "WAREHOUSE MANAGER",
}